export default __webpack_public_path__ + "static/media/logo.d663f3a8.svg";